import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@mui/styles';

const styles = theme => ({
    notify: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
        color: theme.palette.grey[700],
        fontFamily: '\'DM Sans\', "Roboto", "Helvetica", "Arial", sans-serif'
    }
});

const EmptyTableNotification = props => {
    const { classes, message, t } = props;

    return <p className={classes.notify}>{message || t('emptyTableNotification')}</p>;
};

EmptyTableNotification.propTypes = {
    classes: PropTypes.shape({
        notify: PropTypes.string,
    }),
    message: PropTypes.node
};

export default withStyles(styles)(EmptyTableNotification);
